import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

export function useNotifications(enabled: boolean) {
  const [unreadCount, setUnreadCount] = useState(0);
  const [celebration, setCelebration] = useState<any | null>(null);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const res = await api.getNotifications();
      setUnreadCount(res.data?.unreadCount || 0);
    } catch {
      /* ignore */
    }
  }, [enabled]);

  const checkCelebration = useCallback(async () => {
    if (!enabled) return;
    try {
      const res = await api.getUnreadCelebration();
      if (res.data?.notification) {
        setCelebration(res.data.notification);
      }
    } catch {
      /* ignore */
    }
  }, [enabled]);

  const dismissCelebration = useCallback(async () => {
    if (!celebration?._id) {
      setCelebration(null);
      return;
    }
    try {
      await api.markNotificationRead(celebration._id);
    } finally {
      setCelebration(null);
      refresh();
    }
  }, [celebration, refresh]);

  useEffect(() => {
    refresh();
    checkCelebration();
    const id = window.setInterval(refresh, 60000);
    return () => window.clearInterval(id);
  }, [refresh, checkCelebration]);

  return {
    unreadCount,
    celebration,
    refresh,
    checkCelebration,
    dismissCelebration,
  };
}
